import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const developerApi = createApi({
  reducerPath: 'developerApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: ['DeveloperProfile', 'SalesExec'],
  endpoints: () => ({})
})

export default developerApi
